import { render, staticRenderFns } from "./EntitiesCrud.vue?vue&type=template&id=1bb8c700&scoped=true"
import script from "./EntitiesCrud.vue?vue&type=script&lang=js"
export * from "./EntitiesCrud.vue?vue&type=script&lang=js"
import style0 from "./EntitiesCrud.vue?vue&type=style&index=0&id=1bb8c700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8c700",
  null
  
)

export default component.exports